import { useMutation } from '@tanstack/react-query'
import {
  updateStudyUserStudiesStudyIdUsersUserIdPut,
  UpdateStudyUserStudiesStudyIdUsersUserIdPutResponse,
  HTTPValidationError,
  UserCreateSchema,
} from '@common/config/api/client'

import { queryClient } from '@common/config/api/queryClient'
import { AxiosError } from 'axios'
import queryKeyFactory from '../queryKeyFactory'

interface Params {
  studyId: string
  userId: string
  userData: UserCreateSchema
}

export default function useUpdateUser() {
  return useMutation<UpdateStudyUserStudiesStudyIdUsersUserIdPutResponse, AxiosError<HTTPValidationError>, Params>({
    mutationFn: async ({ studyId, userId, userData }) => {
      const response = await updateStudyUserStudiesStudyIdUsersUserIdPut({
        path: {
          study_id: studyId,
          user_id: userId,
        },
        body: {
          role_id: userData.role_id,
          company_id: userData.company_id,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
        },
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeyFactory.allUsers() })
    },
  })
}
